import React from 'react';
import classNames from 'classnames/bind.js';
import proptypes from 'prop-types';
const { bool, oneOfType, array, string } = proptypes;

import styles from './SeoCopyBlock.module.scss';

const cx = classNames.bind(styles);

const SeoBoldText = ({ children, isBlock }) => {
  const Element = isBlock ? 'p' : 'span';

  return (
    <Element className={cx('seoCopyBlockBoldText')}>
      {children}
    </Element>
  );
};

SeoBoldText.propTypes = {
  isBlock: bool,
  children: oneOfType([array, string]).isRequired
};

SeoBoldText.defaultProps = {
  isBlock: false
};

export default SeoBoldText;
